import React from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import * as IoIcons from 'react-icons/io';

export const SidebarData = [
  {
    title: 'Home',
    path: '/',
    icon: <AiIcons.AiFillHome />,
    cName: 'nav-text'
  },
  {
    title: 'Apresentação',
    path: '/apresentacao',
    icon: <IoIcons.IoIosPaper />,
    cName: 'nav-text'
  },
  {
    title: 'Local',
    path: '/local',
    icon: <IoIcons.IoMdPin />,
    cName: 'nav-text'
  },
  {
    title: 'Programação',
    path: '/programacao',
    icon: <IoIcons.IoIosCalendar />,
    cName: 'nav-text'
  },
  {
    title: 'Valores',
    path: '/valores',
    icon: <FaIcons.FaRegMoneyBillAlt />,
    cName: 'nav-text'
  },
  {
    title: 'Palestrantes',
    path: '/palestrantes',
    icon: <IoIcons.IoIosPerson />,
    cName: 'nav-text'
  },
  {
    title: 'Certidões',
    path: '/certidoes',
    icon: <IoIcons.IoMdFolder />,
    cName: 'nav-text'
  }, 
  // {
  //   title: 'Inscrição',
  //   path: '/inscricao',
  //   icon: <FaIcons.FaCartPlus />,
  //   cName: 'nav-text'
  // },
  {
    title: 'Certificado',
    path: '/certificado',
    icon: <AiIcons.AiFillSafetyCertificate />,
    cName: 'nav-text'
  },
  {
    title: 'Material',
    path: '/material',
    icon: <AiIcons.AiFillBook />,
    cName: 'nav-text'
  },
];
